import { Design } from '@/types';
import { fetchDesign } from '@/utils/http/fetchDesign';
import { Thunk } from '@/redux/types';
import { DesignsFetchAction } from '../types';
import { storeDesignAction } from './storeDesignAction';

export const fetchDesignAction =
  (id: string, signal?: AbortSignal): Thunk<Promise<Design>, DesignsFetchAction> =>
  (dispatch) =>
    fetchDesign(id, undefined, signal).then((design) => {
      dispatch(storeDesignAction(design));
      return design;
    });
